export default {
	data () {
		return {
			isEditMode: false,
			editUser: null,
			userUpdated: false
		}
	},
	methods: {
    enableEditMode (user) {
      this.userUpdated = false
      this.isEditMode = true
      this.editUser = user
    },
    userUpdateSuccessful () {
      this.userUpdated = 'User has been successfully updated.'
      this.cancelEdit()
    },
    cancelEdit () {
      this.isEditMode = false
      this.editUser = null
    }
	}
}
